module.exports = __webpack_public_path__ + "media/se.fe725901.svg";